// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"92ab5999","977":"fe02c5fe"}[chunkId] + ".chunk.js";
};